import { Tooltip } from '@iwoca/orion';
import { CardCvcElement } from '@stripe/react-stripe-js';
import { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';
import { FormattedMessage, useIntl } from 'react-intl';

import messages from './LinkDebitCard.messages';
import styles from './LinkDebitCard.module.css';
import { stripeElementStyles } from './StripeElementStyles';

export const CVVQuestion = ({
    error,
    onFocus,
    onBlur,
    onChange
}: {
    error: boolean | null;
    onFocus?: () => void;
    onBlur?: () => void;
    onChange: (field: StripeCardCvcElementChangeEvent) => void;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.CVVWrapper}>
            <label className={styles.label}>
                <FormattedMessage {...messages.CVV} />
                <Tooltip
                    dataTestId="cvvHelpTooltip"
                    placement="top"
                    content={intl.formatMessage(messages.cvvNumberTooltip)}
                />
            </label>

            {error && (
                <span className={styles.error}>
                    <FormattedMessage {...messages.CVVError} />
                </span>
            )}
            <CardCvcElement
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                options={{
                    style: stripeElementStyles
                }}
            />
        </div>
    );
};
